import { Box, Grid } from '@factorialco/deprecated-design-system'

import PricingFaq from 'modules/billing/components/PricingFaq'

import ModulesList from './_ModulesList'
import Summary from './_Summary'

const FactorialCustomBundles = () => {
  return (
    <Box width="full" alignSelf="center" style={{ maxWidth: '1120px' }} gap="s64">
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 12, s: 8 }}>
          <ModulesList />
        </Box>
        <Box gridColSpan={{ xxs: 12, s: 4 }}>
          <Summary />
        </Box>
      </Grid>
      <PricingFaq />
    </Box>
  )
}

export default FactorialCustomBundles
